import tw from 'tailwind-styled-components';

export const MenuContainer = tw.div`
  bg-gray-50 min-h-screen md:bg-transparent md:min-h-0
`;

export const MenuSection = tw.div`
  bg-white px-4 py-2 
  md:px-6 md:py-6 md:border md:border-gray-200 md:rounded-xl md:shadow-sm md:h-full
`;

export const SectionHeader = tw.h3`
  text-lg font-semibold text-gray-900 py-4 border-b border-gray-100 md:text-xl md:py-3 md:mb-4 md:border-b-2 md:border-slate-200
`;

export const MenuItem = tw.div`
  flex items-center justify-between py-4 border-b border-gray-50 last:border-b-0 
  cursor-pointer hover:bg-gray-50 transition-all duration-200
  md:py-3 md:px-3 md:border-b-0 md:mb-1 md:rounded-lg
`;

export const MenuItemIcon = tw.div`
  flex-shrink-0 mr-4 text-gray-500
`;

export const MenuItemText = tw.span`
  flex-1 text-gray-800 font-medium text-sm md:text-base
`;